/**
 * Закриття мега-меню клавішею Esc.
 *
 * Усе інше в панелі (відкриття на наведення й на фокус, вимір висоти, закриття при
 * виході курсора) робить темовий `header-menu.js` — тут лише те, чого в Horizon
 * немає зовсім: реакція на Esc, якої вимагає хендоф.
 *
 * Рішень файл не містить і тому не має тесту — як `tg-product-tabs.js`: DOM-оточення
 * в репо немає, а перевіряти тут нічого, крім самого зв'язування з подією.
 */

(() => {
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const active = document.activeElement;
    if (!(active instanceof Element)) return;

    const menu = active.closest('header-menu');
    if (!menu) return;

    const nav = menu.querySelector('.menu-list');
    if (!(nav instanceof HTMLElement)) return;

    /* Панель закриває САМ перехід фокуса: тема слухає `blur` на пункті меню.
       Тому фокус переносимо на `<nav>`, а не «закриваємо панель» якимось викликом.

       Чому не повернути фокус на сам пункт, як велить звичай: тема відкриває панель
       на `focus` цього ж пункту, тож вона відчинилась би знову тієї ж миті. `<nav>`
       обробників не має — фокус лишається в шапці, наступний Tab іде з першого
       пункту, і панель стоїть закритою. */
    nav.tabIndex = -1;
    nav.focus();
  });
})();
